"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(require("@airasia/phoenix-components/components/Modal"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RoomCard = require("../RoomCard/RoomCard.propTypes");
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));
var _Price = _interopRequireDefault(require("@airasia/phoenix-components/components/Price"));
var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));
var _Benefit = _interopRequireDefault(require("../RoomCard/Benefit"));
var _constant = require("@airasia/phoenix-components/components/AmenitiesCard/constant");
var _Utils = require("./Utils");
var _constants = require("./constants");
var RateDetailModalWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__RateDetailModalWrapper",
  componentId: "sc-fewer8-0"
})(["#airasia-phoenix-modal-content{margin-top:", ";padding:", ";background-color:", ";}font-family:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.none;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.none;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.backgroundColor.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily.default;
});
var RateDetailModalHeader = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__RateDetailModalHeader",
  componentId: "sc-fewer8-1"
})(["box-shadow:0px 2px 6px rgba(0,0,0,0.2);padding:", ";display:flex;align-items:center;"], function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.space.medium, " ").concat(theme.space.normal);
});
var BackButton = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__BackButton",
  componentId: "sc-fewer8-2"
})(["margin-right:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.normal;
});
var Title = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__Title",
  componentId: "sc-fewer8-3"
})(["font-size:", ";font-weight:", ";line-height:", ";color:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.normal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeight.medium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.neutral;
});
var RoomInfo = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__RoomInfo",
  componentId: "sc-fewer8-4"
})(["padding:", ";display:flex;align-items:center;"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.small;
});
var HeroImage = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__HeroImage",
  componentId: "sc-fewer8-5"
})(["width:66px;height:66px;border-radius:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.borderRadius.normal;
});
var RoomNameAndAddress = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__RoomNameAndAddress",
  componentId: "sc-fewer8-6"
})(["margin-left:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.space.XSmall;
});
var RoomName = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__RoomName",
  componentId: "sc-fewer8-7"
})(["font-size:", ";font-weight:", ";line-height:", ";color:", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontSize.normal;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontWeight.medium;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.neutral;
});
var Address = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__Address",
  componentId: "sc-fewer8-8"
})(["font-size:", ";line-height:", ";color:", ";margin-bottom:", ";"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontSize.XSmall;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.lineHeight.small;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.greyDarker;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.space.micro;
});
var At = _styledComponents.default.span.withConfig({
  displayName: "RateDetailModal__At",
  componentId: "sc-fewer8-9"
})(["color:", ";"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.greyDark;
});
var CTAWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__CTAWrapper",
  componentId: "sc-fewer8-10"
})(["display:flex;padding:", ";align-items:center;background-color:", ";border:1px solid ", ";"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.space.small;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.backgroundColor.primary;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.colors.greyLight;
});
var PriceWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__PriceWrapper",
  componentId: "sc-fewer8-11"
})(["font-size:", ";line-height:", ";"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.fontSize.XSmall;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.lineHeight.XSmall;
});
var PerRoomPerNight = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__PerRoomPerNight",
  componentId: "sc-fewer8-12"
})(["margin-bottom:", ";color:", ";"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.space.mini;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.greyDark;
});
var TotalPrice = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__TotalPrice",
  componentId: "sc-fewer8-13"
})(["line-height:", ";color:", ";"], function (_ref30) {
  var theme = _ref30.theme;
  return theme.lineHeight.XSmall;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.colors.greyDarker;
});
var Currency = _styledComponents.default.span.withConfig({
  displayName: "RateDetailModal__Currency",
  componentId: "sc-fewer8-14"
})(["font-size:", ";"], function (_ref32) {
  var theme = _ref32.theme;
  return theme.fontSize.XSmall;
});
var TotalValue = _styledComponents.default.span.withConfig({
  displayName: "RateDetailModal__TotalValue",
  componentId: "sc-fewer8-15"
})(["font-size:", ";font-weight:", ";"], function (_ref33) {
  var theme = _ref33.theme;
  return theme.fontSize.XSmall;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.fontWeight.medium;
});
var ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__ButtonWrapper",
  componentId: "sc-fewer8-16"
})(["margin-left:auto;"]);
var BenefitsAndAmenitiesWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__BenefitsAndAmenitiesWrapper",
  componentId: "sc-fewer8-17"
})(["padding:", ";"], function (_ref35) {
  var theme = _ref35.theme;
  return theme.space.small;
});
var BenefitsWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__BenefitsWrapper",
  componentId: "sc-fewer8-18"
})(["display:flex;padding:", ";"], function (_ref36) {
  var theme = _ref36.theme;
  return "".concat(theme.space.micro, " 0");
});
var Includes = _styledComponents.default.div.withConfig({
  displayName: "RateDetailModal__Includes",
  componentId: "sc-fewer8-19"
})(["font-style:normal;font-weight:normal;font-size:10px;line-height:150%;text-align:right;color:#75767a;mix-blend-mode:normal;padding-bottom:", ";"], function (_ref37) {
  var theme = _ref37.theme;
  return theme.space.tiny;
});
var RateDetailModal = function RateDetailModal(_ref38) {
  var theme = _ref38.theme,
    onClose = _ref38.onClose,
    isOpen = _ref38.isOpen,
    rate = _ref38.rate,
    heroImage = _ref38.heroImage,
    address = _ref38.address,
    onSelectRoomHandler = _ref38.onSelectRoomHandler,
    name = _ref38.name,
    locale = _ref38.locale,
    translations = _ref38.translations,
    zIndex = _ref38.zIndex,
    isSnap = _ref38.isSnap;
  var ratePlanDetails = translations.ratePlanDetails,
    atText = translations.at,
    perRoomPerNight = translations.perRoomPerNight,
    totalText = translations.total,
    freeCancellation = translations.freeCancellation,
    payLater = translations.payLater,
    nonRefundable = translations.nonRefundable,
    partiallyRefundable = translations.partiallyRefundable,
    payAtHotel = translations.payAtHotel;
  var CTAButtonText = rate.CTAButtonText,
    amenities = rate.amenities,
    cancellationPenaltyType = rate.cancellationPenaltyType,
    freeCancellationText = rate.freeCancellationText,
    payAtHotelText = rate.payAtHotelText,
    price = rate.price,
    totalPrice = rate.totalPrice,
    payLaterText = rate.payLaterText,
    nonRefundableText = rate.nonRefundableText,
    instantConfirmationText = rate.instantConfirmationText,
    partiallyRefundableText = rate.partiallyRefundableText,
    perGuestText = rate.perGuestText,
    snapPriceText = rate.snapPriceText,
    baseRate = rate.baseRate;
  return /*#__PURE__*/_react.default.createElement(RateDetailModalWrapper, null, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    openModal: isOpen,
    theme: theme,
    showCloseIcon: false,
    fullScreen: true,
    zIndex: zIndex,
    viewPort: "full_width"
  }, /*#__PURE__*/_react.default.createElement(RateDetailModalHeader, null, /*#__PURE__*/_react.default.createElement(BackButton, {
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    fontsize: "titleNormal",
    icon: "ArrowBackIcon",
    color: "greyDark"
  })), /*#__PURE__*/_react.default.createElement(Title, null, ratePlanDetails)), /*#__PURE__*/_react.default.createElement(RoomInfo, null, /*#__PURE__*/_react.default.createElement(HeroImage, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: heroImage,
    width: "100%",
    height: "100%",
    centerFocus: true,
    enableProgressiveImageLoading: true,
    lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE,
    radius: "4px"
  })), /*#__PURE__*/_react.default.createElement(RoomNameAndAddress, null, /*#__PURE__*/_react.default.createElement(RoomName, null, name), address && /*#__PURE__*/_react.default.createElement(Address, null, /*#__PURE__*/_react.default.createElement(At, null, atText), " ".concat(address.city, " ").concat(address.country)))), /*#__PURE__*/_react.default.createElement(CTAWrapper, null, /*#__PURE__*/_react.default.createElement(PriceWrapper, null, (price === null || price === void 0 ? void 0 : price.value) && /*#__PURE__*/_react.default.createElement(_Price.default, {
    amount: price.value,
    currency: price.currency,
    allowLocaleFormat: true,
    noDecimalValues: true,
    customProperties: {
      marginRight: '-8px'
    },
    locale: locale,
    customCurrencySize: "normal"
  }), isSnap && (baseRate === null || baseRate === void 0 ? void 0 : baseRate.value) && /*#__PURE__*/_react.default.createElement(_Price.default, {
    amount: baseRate.value,
    currency: baseRate.currency,
    allowLocaleFormat: true,
    noDecimalValues: true,
    customProperties: {
      marginRight: '-8px'
    },
    locale: locale,
    customCurrencySize: "normal"
  }), !isSnap && /*#__PURE__*/_react.default.createElement(PerRoomPerNight, null, perRoomPerNight), perGuestText && isSnap && /*#__PURE__*/_react.default.createElement(PerRoomPerNight, null, perGuestText), snapPriceText && /*#__PURE__*/_react.default.createElement(Includes, null, snapPriceText), (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.value) && /*#__PURE__*/_react.default.createElement(TotalPrice, null, /*#__PURE__*/_react.default.createElement(Currency, null, totalPrice.currency), /*#__PURE__*/_react.default.createElement(TotalValue, null, " ".concat((0, _Utils.currencyFormat)(totalPrice.value), " ").concat(totalText)))), /*#__PURE__*/_react.default.createElement(ButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    border: "primary",
    hoverColor: "default",
    hoverBackgroundColor: "primary",
    width: "164px",
    paddingLeft: "0px",
    paddingRight: "0px",
    handleClick: function handleClick() {
      return onSelectRoomHandler(rate);
    },
    backgroundColor: "primary",
    color: "default"
  }, CTAButtonText))), /*#__PURE__*/_react.default.createElement(BenefitsAndAmenitiesWrapper, null, (0, _Utils.isNotEmpty)(freeCancellationText) && /*#__PURE__*/_react.default.createElement(BenefitsWrapper, null, /*#__PURE__*/_react.default.createElement(_Benefit.default, {
    icon: "CheckIcon",
    primaryText: freeCancellation,
    secondaryText: freeCancellationText,
    color: "blue",
    cancellationPenaltyType: cancellationPenaltyType
  })), (0, _Utils.isNotEmpty)(payLaterText) && /*#__PURE__*/_react.default.createElement(BenefitsWrapper, null, /*#__PURE__*/_react.default.createElement(_Benefit.default, {
    icon: "CreditCardIcon",
    primaryText: payLater,
    secondaryText: payLaterText,
    color: "tertiary",
    cancellationPenaltyType: cancellationPenaltyType
  })), (0, _Utils.isNotEmpty)(nonRefundableText) && /*#__PURE__*/_react.default.createElement(BenefitsWrapper, null, /*#__PURE__*/_react.default.createElement(_Benefit.default, {
    icon: "FiberManualRecordIcon",
    primaryText: nonRefundable,
    secondaryText: !isSnap ? nonRefundableText : null,
    color: "orangeDark",
    cancellationPenaltyType: cancellationPenaltyType
  })), (0, _Utils.isNotEmpty)(partiallyRefundableText) && /*#__PURE__*/_react.default.createElement(BenefitsWrapper, null, /*#__PURE__*/_react.default.createElement(_Benefit.default, {
    icon: "FiberManualRecordIcon",
    primaryText: partiallyRefundable,
    secondaryText: partiallyRefundableText,
    color: "yellow",
    cancellationPenaltyType: cancellationPenaltyType
  })), (0, _Utils.isNotEmpty)(payAtHotelText) && /*#__PURE__*/_react.default.createElement(BenefitsWrapper, null, /*#__PURE__*/_react.default.createElement(_Benefit.default, {
    icon: "CreditCardIcon",
    primaryText: payAtHotel,
    secondaryText: payAtHotelText,
    color: "tertiary",
    cancellationPenaltyType: cancellationPenaltyType
  })), (0, _Utils.isNotEmpty)(instantConfirmationText) && /*#__PURE__*/_react.default.createElement(BenefitsWrapper, null, /*#__PURE__*/_react.default.createElement(_Benefit.default, {
    icon: "FlashOnRoundedIcon",
    primaryText: instantConfirmationText,
    color: "greyDark"
  })), amenities.length > 0 && amenities.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(BenefitsWrapper, null, /*#__PURE__*/_react.default.createElement(_Benefit.default, {
      icon: _constant.ICON_RATES_AMENITIES[item.id],
      secondaryText: item.name,
      color: "greyDarker"
    }));
  }))));
};
RateDetailModal.propTypes = _RoomCard.RateDetailModalPropTypes;
RateDetailModal.defaultProps = _RoomCard.RateDetailModalDefaultValues;
var _default = RateDetailModal;
exports.default = _default;